import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useRouting from "../hooks/useRouting";
import { FilledButton } from "../components/common/Button";
import Card from "../components/common/Card";
import useDisplayNotifications from "../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../models/DisplayNotification";
import { BRAND_ASSETS } from "../config/defaultAssetUrls";



const VerifyEmailPage: React.FC = () => {

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const { error, loading, verifyEmail, logout } = useAuth();

  const [successfullyVerified, setSuccessfullyVerified] = useState(true);
  const { goToLoginFreelancers } = useRouting();
  const { addNotification } = useDisplayNotifications();

  useEffect(() => {
    if (token) {
      // Verify email
      verifyEmail(token).then(
        (res) => {
          logout();
          addNotification({
            message: "Successfully verified. Please re-login to continue.",
            type: DisplayNotificationType.SUCCESS
          });
          setSuccessfullyVerified(true);
        }
      ).catch(
        (err) => {
        }
      );

    } else {
    }
  }, [token]);

  return (
    <div className="h-screen flex justify-center p-20">
      <div className="flex flex-col items-center">
        <img
          src={BRAND_ASSETS.LOGO}
          alt="Gamershome Logo"
          className="w-80"
        />

        {/* Loading State */}
        {loading && (
          <h2 className="">
            Verifying email...
          </h2>
        )}

        {successfullyVerified && <div>
          <p className="body2 text-success my-4">Your Email has been verified!</p>
        </div>}

        {/* Error State */}
        {error &&
          <p className="body2 text-danger my-4">
            Something went wrong. Please try again or contact support.
          </p>}

        {/* Go to Login Button */}
        <div className="mt-4">
          <FilledButton
            onClick={goToLoginFreelancers}
            disabled={!successfullyVerified}>
            Login again
          </FilledButton>
        </div>
      </div>
    </div>
  );
};


export default VerifyEmailPage;